var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9678 12.9791V15.3877C16.9687 15.6113 16.9229 15.8327 16.8333 16.0375C16.7438 16.2424 16.6124 16.4263 16.4476 16.5775C16.2828 16.7286 16.0883 16.8437 15.8765 16.9154C15.6647 16.987 15.4402 17.0136 15.2175 16.9935C12.7469 16.725 10.3737 15.8808 8.28865 14.5286C6.34875 13.2959 4.70406 11.6512 3.47136 9.71135C2.11448 7.61679 1.27006 5.23206 1.00652 2.75036C0.986453 2.52834 1.01284 2.30457 1.084 2.0933C1.15515 1.88203 1.26952 1.6879 1.41981 1.52325C1.57011 1.35861 1.75304 1.22706 1.95696 1.13699C2.16088 1.04691 2.38132 1.00029 2.60425 1.00008H5.0129C5.40254 0.996243 5.78028 1.13422 6.07572 1.3883C6.37116 1.64237 6.56413 1.99521 6.61866 2.38103C6.72032 3.15185 6.90886 3.9087 7.18068 4.63713C7.2887 4.9245 7.31208 5.23682 7.24804 5.53707C7.18401 5.83732 7.03525 6.11292 6.81938 6.33121L5.79972 7.35087C6.94267 9.36092 8.60696 11.0252 10.617 12.1682L11.6367 11.1485C11.855 10.9326 12.1306 10.7839 12.4308 10.7198C12.7311 10.6558 13.0434 10.6792 13.3308 10.7872C14.0592 11.059 14.816 11.2476 15.5869 11.3492C15.9769 11.4042 16.333 11.6007 16.5877 11.9012C16.8423 12.2017 16.9776 12.5853 16.9678 12.9791Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.c0e1898b515c9e256927cf17ba5c0223.svg";
export { ForwardRef as ReactComponent };